export const ErrorMessages: Record<string, string> = {
  MISSING_REQUIRED_FIELDS:
    "必要な情報が不足しています: sender、activation_key、activated_at",
  INVALID_SENDER_DOMAIN: "メールはSoftgateドメインから送信されていません。",
  LICENSE_NOT_FOUND: "ライセンスがシステムに見つかりません。",
  LICENSE_STATE_NOT_REQUESTING:
    "ライセンスのステータスがREQUESTINGではありません",
  UNKNOWN_ERROR: "ライセンスのアクティベーション中に不明なエラーが発生しました",
  NO_RESPONSE_FROM_SOFTGATE:
    "4時間以内にSoftgateからの応答がありませんでした。",
};
